import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { register, unregister } from 'util/dom/channeled-interactionobserver';

export default class LazyImage extends Component {
    static propTypes = {
        children: PropTypes.any,
    };

    state = {
        isVisible: false,
    };

    componentDidMount() {
        register(this, 'lazy-image', {
            threshold: 0.05,
            rootMargin: '200px',
        });
    }

    componentWillUnmount() {
        unregister(this);
    }

    render() {
        if (Array.isArray(this.props.children)) {
            debugger;
            const children = this.props.children.map((child, index) => {
                return React.cloneElement(child, {
                    index,
                });
            });

            return (
                { children }
            );
        }

        return (
            <div ref='root'>
                { React.cloneElement(this.props.children, {
                    src: this.state.isVisible ? this.props.children.props['data-src'] : null,
                    'src-set': this.state.isVisible ? this.props.children.props['data-src-set'] : null,
                }) }
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/lazy-image/index.js